// Set user
export function updateUser(state, payload) {
  state.user = payload;
}
export function updateUserSettings(state, payload) {
  state.user.settings = payload;
}
export function updateLoggedIn(state, payload) {
  state.isLoggedIn = payload;
}
export function updateFavorites(state, payload) {
  state.user.favorites = payload;
}
export function setAsFavorite(state, payload) {
  if (!state.user.favorites) {
    state.user.favorites = [];
  }

  state.user.favorites.push(payload);
}
export function removeAsFavorite(state, payload) {
  state.user.favorites = state.user.favorites.filter(function (item) {
    return item !== payload;
  });
}
export function flush(state) {
  state.user = [];
  state.pushToken = '';
}
export function updatePushToken(state, payload) {
  state.pushToken = payload;
}